// extracted by mini-css-extract-plugin
module.exports = {"info":"budget-list_info_1vR9s","actions":"budget-list_actions_2LbpB","icon":"budget-list_icon_wrKVx","status":"budget-list_status_3vouf","email":"budget-list_email_12IeG"};